var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.3507 3.59882C15.3507 2.17134 16.5205 1.0006 17.9463 1L17.9464 1.00045H21.0526C22.4797 1.00045 23.6515 2.1722 23.6515 3.59926V14.3505V15.3505H24.6515H35.4011C36.8283 15.3505 38 16.5222 38 17.9493V21.0554C38 22.4824 36.8285 23.654 35.4015 23.6543C35.4014 23.6543 35.4013 23.6543 35.4011 23.6543L24.6502 23.65L23.6498 23.6496V24.65V35.4012C23.6498 36.8283 22.4781 38 21.0509 38H17.9448C16.5177 38 15.3459 36.8283 15.3459 35.4012L15.3502 24.6504L15.3506 23.65H14.3502H3.59886C2.17175 23.65 1 22.4782 1 21.0512V17.945C1 16.5179 2.17175 15.3462 3.59886 15.3462H14.3485H15.3483L15.3485 14.3464L15.3507 3.59902V3.59882Z","stroke":"black","strokeWidth":"2"}));
}

Plus.defaultProps = {"width":"39","height":"39","viewBox":"0 0 39 39","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
